<template>
  <div class="afdc-container-fluid">
    <div class="afdc-row" id="afdc-analyze">
      <router-view v-if="$store.getters.isNavActiveTabAnalyze"/>

      <div v-bind:class="$store.getters.getAnalyzeShowFilters ? 'afdc-col-sm-8 afdc-filters' : 'afdc-col-sm-8 afdc-filters afdc-analyze-map'">
        <div v-if="$store.getters.getAnalyzeShowFilters" class="afdc-row">
          <div class="afdc-col-sm-auto">
            <ul id="afdc-analyze-tabs" class="afdc-nav afdc-nav-pills" role="tablist" aria-orientation="vertical">
              <li class="afdc-nav-item">
                <router-link to="/analyze" event="" v-on:click.native.prevent="clickTab('location')" v-bind:class="{ 'afdc-nav-link': true, 'afdc-active': isTabActiveLocation }" id="afdc-analyze-location-tab" role="tab" aria-controls="afdc-analyze-location" v-bind:aria-selected="isTabActiveLocation ? 'true' : 'false'">
                  <img src="../assets/images/icon-analyze-location.png" alt="">
                  <div class="afdc-tab-name">{{ $t('Location') }}</div>
                </router-link>
              </li>
              <li class="afdc-nav-item">
                <router-link to="/analyze" event="" v-on:click.native.prevent="clickTab('fuel')" v-bind:class="{ 'afdc-nav-link': true, 'afdc-active': isTabActiveFuel }" id="afdc-analyze-fuel-tab" role="tab" aria-controls="afdc-analyze-fuel" v-bind:aria-selected="isTabActiveFuel ? 'true' : 'false'">
                  <img src="../assets/images/icon-analyze-fuel.png" alt="">
                  <div class="afdc-tab-name">{{ $t('Fuel') }}</div>
                </router-link>
              </li>
              <li class="afdc-nav-item">
                <router-link to="/analyze" event="" v-on:click.native.prevent="clickTab('station')" v-bind:class="{ 'afdc-nav-link': true, 'afdc-active': isTabActiveStation }" id="afdc-analyze-station-tab" role="tab" aria-controls="afdc-analyze-station" v-bind:aria-selected="isTabActiveStation ? 'true' : 'false'">
                  <img src="../assets/images/icon-analyze-station.png" alt="">
                  <div class="afdc-tab-name">{{ $t('Station') }}</div>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="afdc-col-sm afdc-tab-content">
            <template v-if="$store.getters.getAnalyzeError">
              <p class="afdc-alert afdc-alert-warning"><em>{{ $store.getters.getAnalyzeError }}</em></p>
            </template>

            <div v-bind:class="{ 'afdc-tab-pane': true, 'afdc-active': isTabActiveLocation }" id="afdc-analyze-location" role="tabpanel" aria-labelledby="afdc-analyze-location-tab">
              <analyze-location-filters/>
            </div>
            <div v-bind:class="{ 'afdc-tab-pane': true, 'afdc-active': isTabActiveFuel }" id="afdc-analyze-fuel" role="tabpanel" aria-labelledby="afdc-analyze-fuel-tab">
              <analyze-fuel-filters/>
            </div>
            <div v-bind:class="{ 'afdc-tab-pane': true, 'afdc-active': isTabActiveStation }" id="afdc-analyze-station" role="tabpanel" aria-labelledby="afdc-analyze-station-tab">
              <analyze-station-filters/>
            </div>

            <div class="afdc-analyze-clear-filters" v-if="hasFilters">
              <router-link to="/analyze" class="afdc-dark-link"><font-awesome-icon icon="times-circle" class="afdc-fa-icon"/>{{ $t('clear all filters') }}</router-link>
            </div>
          </div>
        </div>
        <div v-else class="afdc-row afdc-no-gutters">
          <div class="afdc-col-sm-12">
            <div v-if="$store.getters.getLoadingAnalyzeStations" class="afdc-large-spinner-container">
              <div class="afdc-large-spinner"></div>
            </div>

            <div v-if="$store.getters.getAnalyzeMapError" class="afdc-alert afdc-alert-warning afdc-analyze-map-error"><em>{{ $store.getters.getAnalyzeMapError }}</em></div>

            <br>
            <map-stations v-if="$store.getters.isNavActiveTabAnalyze"/>
            <br>
          </div>
        </div>
      </div>

      <div class="afdc-col-sm-4 afdc-results">
        <analyze-results/>
      </div>
    </div>
  </div>
</template>

<script>
import AnalyzeFuelFilters from '@/components/AnalyzeFuelFilters.vue';
import AnalyzeLocationFilters from '@/components/AnalyzeLocationFilters.vue';
import AnalyzeResults from '@/components/AnalyzeResults.vue';
import AnalyzeStationFilters from '@/components/AnalyzeStationFilters.vue';
import MapStations from '@/components/MapStations.vue';

export default {
  components: {
    AnalyzeFuelFilters,
    AnalyzeLocationFilters,
    AnalyzeResults,
    AnalyzeStationFilters,
    MapStations,
  },

  computed: {
    isTabActiveLocation() {
      return this.$store.getters.isNavActiveAnalyzeTabLocation;
    },

    isTabActiveFuel() {
      return this.$store.getters.isNavActiveAnalyzeTabFuel;
    },

    isTabActiveStation() {
      return this.$store.getters.isNavActiveAnalyzeTabStation;
    },

    hasFilters() {
      return (Object.keys(this.$store.getters.getFilters).length > 0);
    },
  },

  methods: {
    clickTab(tab) {
      this.$store.commit('setNavActiveAnalyzeTab', tab);
    },
  },
};
</script>

<style lang="scss">
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/_mixins.scss';

.filters {
  background-color: #ccc;
  .col-form-label {
    text-align: right;
  }
}

.results {
  background-color: #444;
  color: #fff;
}

.analyze-map {
  padding: 0;
}

#analyze-tabs {
  width: 105px;
  padding-bottom: 20px;

  li.nav-item {
    width: 100%;
  }

  a.nav-link {
    width: 100%;
    text-align: center;
    color: #fff;
    background-color: #555;
    border: 1px solid #555;
    border-radius: 0px;
    line-height: 100%;
    padding: 15px 5px;

    @include media-breakpoint-up(sm) {
      margin-top: 20px;
      -webkit-border-radius: 10px;
      -moz-border-radius: 10px;
      border-radius: 10px;
    }

    &:hover {
      background-color: #777;
      border: 1px solid #777;
    }

    .tab-name {
      margin-top: 6px;
    }
  }

  a.nav-link.active {
    background-color: #B65116;
    border: 1px solid #fff;
    box-shadow: 0 4px 8px 0 rgba(255, 255, 255, .5), 0 6px 20px 0 rgba(255, 255, 255, .5);
  }
}

#analyze {
  position: relative;

  .tab-content {
    height: auto;
    max-height: 630px;
    overflow: auto;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .custom-checkbox {
    margin-bottom: 5px;
  }
}

.analyze-clear-filters {
  text-align: right;
  margin-top: 40px;

  a {
    font-size: 14px;

    .fa-icon {
      margin-right: 4px;
    }
  }
}

.analyze-map-error {
  margin-bottom: 0;
}
</style>
